import * as React from 'react';
import { Alert, Input, message, Modal } from 'antd';
import ConfigurationService from '../../Service/ConfigurationService';
import { useState } from 'react';
import MailTwoTone from '@ant-design/icons/lib/icons/MailTwoTone';
import { RESET_EMAIL_SENT } from '../../Helper/BannerMessages';

export default function ResetPasswordModal () {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [visible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const sendResetPasswordRequest = async () => {
    try {
      await setLoading(true)
      const response = await fetch(ConfigurationService.urls().resetPasswordUrl, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ email })
      });

      // Read as text first: an HTML error page made `json()` throw the status itself away
      const body = await response.text();
      let responseJson: any = null;

      try {
        responseJson = body ? JSON.parse(body) : null;
      } catch (parseError) {
        responseJson = null;
      }

      await setLoading(false);

      if (response.status === 200) {
        message.success({ content: RESET_EMAIL_SENT });
        await setError('');
        await setVisible(false);
      }
      else {
        await setError(typeof responseJson?.message === 'string'
          ? responseJson.message
          : `The request failed (${response.status})`);
      }
    } catch (err) {
      console.error(err);
      await setError(err.message);
      await setLoading(false);
    }
  }

  return (
    <div style={{ padding: '0 10px' }}>
      <div style={{ textAlign: 'right' }}>
        <a onClick={() => setVisible(true)}>
          Forgot password
        </a>
      </div>
      <Modal title="Reset Password Form"
         open={visible}
         maskClosable={false}
         onOk={sendResetPasswordRequest}
         okButtonProps={{ loading }}
         okText={'Reset my password'}
         cancelButtonProps={{ style: { display: 'none' } }}
         onCancel={() => setVisible(false)}
      >
        {error
          ? <div style={{ padding: '0 0 20px 0' }}><Alert message={error} type="error" showIcon /></div>
          : null
        }
        <div style={{ padding: '5px 0 20px' }}>
          Please enter your email in the field below to receive a link to change your password
        </div>
        <div style={{ fontWeight: "500" }}><MailTwoTone /> Email</div>
        <Input value={email}
           placeholder={'type in your email'}
           onChange={(e) => { setEmail(e.target.value) }}
        />
      </Modal>
    </div>
  )
}
